import { getFontSizeOfHTMLElement } from "./getFontSizeOfHTMLElement";

export function adjustFontSize(element: HTMLElement, container: HTMLElement, originalFontSize: number) {
    let currentSize = getFontSizeOfHTMLElement(element);
    if (isOverflown(element, container)) {
        while (isOverflown(element, container)) {
            currentSize--;
            element.style.fontSize = `${currentSize}px`;
        }
    } else if (currentSize < originalFontSize) {
        while (!isOverflown(element, container)) {
            currentSize++;
            if (currentSize > originalFontSize) {
                break;
            }
            element.style.fontSize = `${currentSize}px`;
        }
        currentSize = Math.min(originalFontSize, currentSize - 1);
        element.style.fontSize = `${currentSize}px`;
    }
}

function isOverflown(element: HTMLElement, parent: HTMLElement) {
    return element.clientHeight > parent.clientHeight || element.clientWidth > parent.clientWidth;
}
